import { ArrowUp } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";
import { Reveal } from "@/components/Reveal";

export const Footer = () => (
  <footer data-testid="site-footer" className="border-t border-white/10 bg-[#201e32] px-5 py-16 text-[#f3f0e8] sm:px-8 sm:py-20 lg:px-10">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <p className="font-display text-3xl font-bold leading-tight tracking-[-0.03em] sm:text-4xl">
          You bring the spark.
          <br />
          <span className="text-[#a277fa]">We make it visible.</span>
        </p>
      </Reveal>

      <div className="mt-14 flex flex-col justify-between gap-10 border-t border-white/10 pt-10 lg:flex-row lg:items-end">
        <div>
          <p className="font-display text-[clamp(3rem,9vw,7rem)] font-extrabold leading-none tracking-[-0.05em]">
            elavate<span className="text-[#7650c7]">.</span>
          </p>
          <p className="mt-4 max-w-[420px] text-sm leading-relaxed text-white/50">
            Thoughtful websites for real people. Made carefully in the UK, since 2018.
          </p>
        </div>

        <div className="flex flex-col gap-6 sm:items-end">
          <a
            data-testid="footer-email-link"
            href="mailto:sales@elavatestudios.com"
            className="w-fit text-sm font-semibold text-[#f4d35e] underline decoration-[#7650c7] decoration-2 underline-offset-4 transition-colors hover:text-[#a277fa]"
          >
            sales@elavatestudios.com
          </a>
          <div className="flex items-center gap-5">
            <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/35">
              © 2026 Elavate Studios
            </p>
            <button
              data-testid="footer-back-to-top-button"
              onClick={() => scrollToSection(0)}
              aria-label="Back to top"
              className="flex h-11 w-11 items-center justify-center rounded-full border border-white/15 text-[#f3f0e8] transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-[#7650c7]"
            >
              <ArrowUp size={17} aria-hidden />
            </button>
          </div>
        </div>
      </div>
    </div>
  </footer>
);
